function getUId(book){
    if(!book) throw "Book empty";
    var uid = book.ASIN;
    if(uid.length==0) uid = book.ISBN;
    return String(uid).padStart(10, '0');
};

function getBBGRating(book){
    if(!book) throw "Book empty";
    return Math.round(book.BBGRating * 100 , 2) / 100
}

function getDate(book){
    if(!book) throw "Book empty";
    if(book.PublishDate < 1900)
    {
        return book.PublishDate;
    }
    return new Date(book.PublishDate).getFullYear()
}

module.exports = { 
    getUId,
    getBBGRating,
    getDate
}